import AppDownloadButton from "../button/AppDownloadButton";

interface CallToActionProps {}

export default function CallToAction(props: CallToActionProps) {
    
    return (
        <div className="section items-center bg-gradient-to-r from-cyan-500 to-blue-500">
            <div className="max-w-4xl text-center py-0 lg:py-20">
                <h1 className="text-4xl/snug lg:text-6xl/snug text-gray-100 font-bold tracking-wider">
                    Join the Movement. Start Earning Today.
                </h1>
                <p className="text-xl text-gray-100 mt-7">
                    Enanpay isn’t just an app — it’s your everyday money companion. Whether you're earning, saving, or paying, we’ve got you covered.
                </p>
                <div className="mt-8 flex flex-wrap justify-center gap-x-6 gap-y-4">
                    <AppDownloadButton 
                        type="google"
                        size="xs"
                    />
                    <AppDownloadButton 
                        type="apple"
                        size="xs"
                    />
                </div>
            </div>
        </div>
    );
}